import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../services';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.userService.getToken() && this.userService.getData()) {
            return true;
        }
        else if (!this.userService.getToken() && this.userService.getData()) {
            this.router.navigate(['/lock']);
        }
        else {
            this.router.navigate(['/login']);
        }
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/guards/auth.guard.ts